import React from "react";

const Faqs = () => {
  return (
    <div>
      <h1>Faqs</h1>
    </div>
  );
};

export default Faqs;
